import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';
import { AccentedText } from '../AccentedText/AccentedText';
import './ExternalForm.scss';
import { DOMParseHTMLElement } from '../../shared/stripHtml';
import { isURLValid, queryBuilder } from '../../shared/Utils';

export const ExternalForm = ({ node }) => {
    const { campaignTermsFilter } = useLayoutContext();
    const darkMode = node.field_dark_mode === true ? `dark` : `light`;
    const [queryString, setQueryString] = useState(``);
    const [srcString, setSrcString] = useState<string>(null);
    const fieldText = node.relationships?.field_text;
    const iframeElement = node.field_embed_code;
    const headingAlign = node.field_lc_align;
    const iframeHeight = node.field_form_height;
    const queryParametersToString = queryBuilder(campaignTermsFilter, false);

    useEffect(() => {
        setQueryString(
            `${!queryParametersToString ? `` : queryParametersToString}`
        );
    }, [queryParametersToString]);

    useEffect(() => {
        if (typeof window !== `undefined`) {
            const parsedSrc =
                DOMParseHTMLElement(iframeElement)?.querySelector(
                    `iframe`
                )?.src;
            setSrcString(parsedSrc);
        }
    }, []);

    return (
        <section className={`c--external-form themed-container ${darkMode}`}>
            <div className="kite-container">
                {fieldText?.field_heading && (
                    <h2
                        className={`typestack-title-1 ${
                            headingAlign ? headingAlign.toLowerCase() : ``
                        }`}
                    >
                        <span>
                            <AccentedText>
                                {fieldText?.field_heading}
                            </AccentedText>
                        </span>
                    </h2>
                )}
                {fieldText?.field_content_text?.value && (
                    <div
                        className="typestack-body-1"
                        dangerouslySetInnerHTML={{
                            __html: fieldText?.field_content_text?.value,
                        }}
                    ></div>
                )}
                {srcString && isURLValid(srcString) && (
                    <div className={`iframe-container ${darkMode}`}>
                        <iframe
                            data-id="external-form"
                            src={`${srcString}${queryString}`}
                            frameBorder="0"
                            style={{
                                width: `100%`,
                                border: 0,
                                height: iframeHeight ? `${iframeHeight}px` : ``,
                            }}
                            title={`${fieldText?.field_heading} Form`}
                            allow="transparency"
                        ></iframe>
                    </div>
                )}
            </div>
        </section>
    );
};
